import React from 'react'
import HorizontalLinearStepper from '../Stepform/HorizontalLinearStepper.js'
const Signup = () => {
  return (
    <div>
        <HorizontalLinearStepper />
          
    </div>
  )
}

export default Signup